export default [{
  id: 'carrier_name',
  name: 'Carrier',
}, {
  id: 'carrier_logo',
  name: 'Logo',
}, {
  id: 'display_name',
  name: 'Display Name',
}];
